// extracted by mini-css-extract-plugin
export var header = "_xb-1";
export var maskBottom = "_xb-6";
export var maskMiddle = "_xb-7";
export var maskTop = "_xb-5";
export var root = "_xb-0";
export var scrollDownButton = "_xb-3";
export var scrollDownButtonHidden = "_xb-4";
export var viewport = "_xb-2";